<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">First Day D0/D1/D7</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">Advanced Reports</li>
              <li class="breadcrumb-item active">
                <i class="fas fa-table"></i> First Day D0/D1/D7
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container-fluid">
        <data-table-wrapper
            ref="dataTable"
            :columns="columns"
            :filters="filters"
            :load-data-callback="loadDataCallback"
            :filter-defaults="filterDefaults"
            :show-filters="true"
            disable-primary-column="true"
            disable-edit-action="true"
            disable-delete-action="true"
            :disable-auto-load="true"
            endpoint="/first-day-report"
            api-service="analytics"
        >
        </data-table-wrapper>
      </div>
    </section>
  </div>
</template>

<script>
import DataTableWrapper from '../components/DataTableWrapper';
import {mapGetters} from "vuex";
import * as dateUtils from "@/helpers/dateUtils";
import * as formatUtils from "@/helpers/formatUtils";

const COHORT_TITLES = {
  d0: 'D0, all new players',
  d1: 'D1, returned next day',
  d7: 'D7, returned on day 7',
};

export default {
  components: {
    DataTableWrapper
  },
  data() {
    return {
      loadDataCallback: (component, respData) => {
        component.items = respData;
        component.pagination.onPage = component.pagination.total = component.items.length;
        component.pagination.page = 1;
        component.showEmpty = true;
      },
      filters: [
        {
          field: 'fromDate',
          placeholder: 'From Date',
          label: 'From Date',
          type: 'date-picker',
          shortcuts: dateUtils.getFilterShortcuts()
        },
        {
          field: 'toDate',
          placeholder: 'To Date',
          label: 'To Date',
          type: 'date-picker',
          shortcuts: dateUtils.getFilterShortcuts()
        },
        {
          field: 'gameIds',
          placeholder: 'Select games',
          label: 'Games',
          type: 'multiselect',
          optionLabel: 'name',
          multiple: true,
          getValue: (games) => { return games ? games.map(game => game.id) : [] },
          getOptions: () => this.getGames,
          trackBy: 'id'
        },
        {
          field: 'operatorIds',
          placeholder: 'Select operators',
          label: 'Operators',
          type: 'multiselect',
          optionLabel: 'name',
          multiple: true,
          getValue: (operators) => { return operators ? operators.map(operator => operator.id) : [] },
          getOptions: () => this.getOperators,
          trackBy: 'id'
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'getGames',
      'getOperators',
    ]),
    filterDefaults() {
      return {
        fromDate: dateUtils.getTodayDate(),
        toDate: dateUtils.getTodayEndDate(),
      };
    },
    columns() {
      return [
        {
          field: 'cohort',
          title: 'Group',
          sorting: false,
          callback: ({row}) => COHORT_TITLES[row.cohort] || row.cohort,
        },
        {field: 'players', title: 'Players', sorting: false},
        {field: 'eligible_players', title: 'Base players', sorting: false},
        this.numberColumn('retention_percent', 'Retention %'),
        this.numberColumn('bets_sum_eur', 'Bets sum, EUR'),
        this.numberColumn('wins_sum_eur', 'Wins sum, EUR'),
        {field: 'bets_count', title: 'Bets count', sorting: false},
        this.numberColumn('bets_per_player', 'Bets per player'),
        this.numberColumn('bets_per_session', 'Bets per session'),
        {field: 'sessions', title: 'Sessions', sorting: false},
        this.numberColumn('sessions_per_player', 'Sessions per player'),
        this.numberColumn('slots_per_player', 'Slots per player'),
        this.numberColumn('rtp', 'RTP %'),
      ];
    },
  },
  methods: {
    numberColumn(field, title) {
      return {
        field,
        title,
        sorting: false,
        callback: ({row}) => row[field] != null ? formatUtils.formatNumberToFixed(row[field], 2) : '',
      };
    },
  },
}
</script>
